/**
 * @class SettingsItem
 */
export default class SettingsItem {
    /**
     * @param {String}  name
     * @param {String}  type
     * @param {any}     value
     * @param {any}     defaultValue
     * @param {Boolean} visible
     * @param {Boolean} editable
     * @param {Array}   keyWords
     */
    constructor(name, type, value, defaultValue, visible = false, editable = false, keyWords = []) {
        this._name = name;
        this._type = type;
        this._value = value;
        this._defaultValue = defaultValue;
        this._visible = visible;
        this._editable = editable;
        this._keyWords = keyWords;

        if (typeof this._name !== "string") {
            throw new Error("Invalid datatype of name");
        }
    }

    /**
     * @return {String}
     */
    get name() {
        return this._name;
    }

    /**
     * @param {String} name
     */
    set name(name) {
        this._name = name;
    }

    /**
     * @return {String}
     */
    get type() {
        return this._type;
    }

    /**
     * @param {String} type
     */
    set type(type) {
        this._type = type;
    }

    /**
     * @return {any}
     */
    get value() {
        return this._value;
    }

    /**
     * @param {any} value
     */
    set value(value) {
        this._value = value;
    }

    /**
     * @return {any}
     */
    get defaultValue() {
        return this._defaultValue;
    }

    /**
     * @param {any} defaultValue
     */
    set defaultValue(defaultValue) {
        this._defaultValue = defaultValue;
    }

    /**
     * @return {Boolean}
     */
    get visible() {
        return this._visible;
    }

    /**
     * @param {Boolean} visible
     */
    set visible(visible) {
        this._visible = visible;
    }

    /**
     * @return {Boolean}
     */
    get editable() {
        return this._editable;
    }

    /**
     * @param {Boolean} editable
     */
    set editable(editable) {
        this._editable = editable;
    }

    /**
     * @return {Array}
     */
    get keyWords() {
        return this._keyWords;
    }

    /**
     * @param {Array} keyWords
     */
    set keyWords(keyWords) {
        this._keyWords = keyWords;
    }

    /**
     * @return {String}
     */
    toString() {
        return "SettingsItem (" + this._name + ")";
    }
}
